<uikit-search-select
  (selection)="addItemListItem($event)"
  [options]="itemMenuOptions()"
  [alwaysFirstValue]="itemConfig.alwaysFirstValue"
  [showSearch]="true"
  [displayProperty]="itemConfig.displayProperty"
  [sorted]="itemConfig.sorted"
  [selected]="appliedSelection.item"
  [placeholderText]="itemConfig.placeholderText"
  [dropdownWidth]="itemConfig.dropdownWidth"
  [closeOnClick]="closeSelectOnClick"
></uikit-search-select>
<div *ngIf="!!appliedSelection.item" class="item-and-status-separator"></div>
<uikit-search-select
  *ngIf="!!appliedSelection.item"
  (selection)="changeItemStatus($event)"
  [options]="statusMenuOptions()"
  [alwaysFirstValue]="statusConfig.alwaysFirstValue"
  [displayProperty]="statusConfig.displayProperty"
  [sorted]="statusConfig.sorted"
  [selected]="appliedSelection?.status"
  [placeholderText]="statusConfig.placeholderText"
  [showSearch]="false"
  [closeOnClick]="closeSelectOnClick"
></uikit-search-select>
<div
  *ngIf="!!appliedSelection.item && appliedSelection.item.editions?.length > 0"
  class="item-and-status-separator"
></div>
<uikit-search-select
  *ngIf="!!appliedSelection.item && appliedSelection.item.editions?.length > 0"
  (selection)="changeItemEdition($event)"
  [options]="editionMenuOptions()"
  [alwaysFirstValue]="editionConfig.alwaysFirstValue"
  [displayProperty]="editionConfig.displayProperty"
  [sorted]="editionConfig.sorted"
  [selected]="appliedSelection?.edition"
  [placeholderText]="editionConfig.placeholderText"
  [showSearch]="false"
  [closeOnClick]="closeSelectOnClick"
></uikit-search-select>
